import React, {Component} from 'react'
import { connect } from 'react-redux'
import { getListUserSell } from '../../actions/sellRequestAction'
import { Alert, Col, Row, Card, CardBody } from 'reactstrap';
import Paginations from '../../components/Paginations/Paginations';
import { CardHeaderWithToolbars,Title } from '../../components/Card/CardHeaderWithToolbars';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import Toolbars from './Filters/Toolbars';
import { DEFAULT_PER_PAGE } from '../../constants/settings';
import { DEFAULT_CATEGORY_NAME } from '../../constants/kickavenue';
import FilterPanel from './warehouse/FilterPanel';
import privateView from '../../components/hocs/privateView';
import List from './warehouse/List'
import { Th } from '../../components/Tbl';
import qs from 'query-string';
import { getOptionList as getCategoryOptionList } from '../../actions/categoriesAction';
import Analytics from "../../services/Analytics";
import { rowsToCsv, downloadCsv, fetchAllPages, ExportLimitError, EXPORT_MAX_ROWS } from '../../utils/exportCsv';
import { goClient, countRows, requestEmailExport, exportStatus, isRequestError } from '../../utils/exportClient';
import ExportModal from '../../components/Export/ExportModal';
import { loadLanguageOptions } from '../../utils/exportOptions';
import WarehouseExportFilters, { WAREHOUSE_EXPORT_DEFAULTS, toWarehouseParams } from './Modals/WarehouseExportFilters';

const defaultParams = {
  per_page: DEFAULT_PER_PAGE,
  status: 'pre_verified_approved',
  size: '',
  pre_verified: 1,
  has_quantity: true,
  is_approved_online_listing: '0',
};

const DEFAULT_ROUTE = '/warehouse';

const ADMIN_ROLES = ['superadministrator', 'administrator'];

// Mirrors the Go export catalogue (internal/modules/exportreport/service/warehouse_source.go).
export const WAREHOUSE_EXPORT_COLUMNS = [
  { name: 'id' }, { name: 'seller_email' }, { name: 'seller_phone', adminOnly: true },
  { name: 'display_name' }, { name: 'SKU' }, { name: 'colour' }, { name: 'image_url' },
  { name: 'category' }, { name: 'rarity' }, { name: 'language' }, { name: 'subcategory' }, { name: 'variant_group' },
  { name: 'size_US' }, { name: 'condition' }, { name: 'quantity' },
  { name: 'asking_price' }, { name: 'purchase_price', adminOnly: true },
  { name: 'rack' }, { name: 'consignment_id' }, { name: 'status' }, { name: 'fulfilment' },
  { name: 'pre_verified' }, { name: 'consignment' },
  { name: 'defects_count' }, { name: 'listing_age_days' },
  { name: 'approved_at' }, { name: 'created_at' }, { name: 'updated_at' }, { name: 'expiry' }, { name: 'note' }
];

const ageDays = (approvedAt, createdAt) => {
  const anchor = approvedAt || createdAt;
  if (!anchor) return '';
  const t = new Date(anchor.replace(' ', 'T'));
  return Number.isNaN(t.getTime()) ? '' : String(Math.floor((Date.now() - t.getTime()) / 86400000));
};

const exportRow = item => {
  const variant = item.product_variant || {};
  const product = variant.product || {};
  const sellRack = item.sell_racks && item.sell_racks.rack;
  const images = variant.product_variant_images || [];
  return {
    id: item.id,
    seller_email: item.user && item.user.email,
    seller_phone: item.user && item.user.phone_number,
    display_name: variant.display_name,
    SKU: variant.SKU,
    colour: variant.colour,
    image_url: images.length ? images[0].URL : '',
    category: product.category && product.category.name,
    rarity: variant.rarity && variant.rarity.name,
    language: variant.language,
    subcategory: variant.subcategory && variant.subcategory.name,
    variant_group: variant.variant_group && variant.variant_group.name,
    size_US: item.size && item.size.US,
    condition: item.sneakers_condition,
    quantity: item.quantity,
    asking_price: item.asking_price,
    purchase_price: item.purchase_price,
    rack: sellRack ? sellRack.name : item.rack,
    consignment_id: item.consignment_id,
    status: item.status,
    fulfilment: item.pre_order ? 'pre_order' : 'ready_stock',
    pre_verified: item.pre_verified ? 1 : 0,
    consignment: item.consignment ? 1 : 0,
    defects_count: (item.defects || []).filter(d => d.value === true).length,
    listing_age_days: ageDays(item.approved_at, item.created_at),
    approved_at: item.approved_at,
    created_at: item.created_at,
    updated_at: item.updated_at,
    expiry: item.expiry,
    note: item.note
  };
};

const pickColumns = (row, columns) => {
  const out = {};
  columns.forEach(c => { out[c] = row[c]; });
  return out;
};

class Warehouse extends Component {
	constructor(props) {
    super(props)
    const params = qs.parse(props.location.search);
		this.state={
      _exportModalOpen: false,
      _isExporting: false,
      _exportProgress: 0,
      _exportRowCount: 0,
      _emailStatus: null,
			_params:{
        ...defaultParams,
        keyword: params.keyword || '',
        seller: ''
      },
      _list: [],
      _pagination: {},
      _filterOpen: params.keyword? true: false,
      _printOpen: false,
      _successAlertOpen: false,
      selectedData: [],
      isDataLoaded: false,
    }
    this._handleApplyFilter = this._handleApplyFilter.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
    this._handleParamsChange = this._handleParamsChange.bind(this);
    this._handleCheckedChange = this._handleCheckedChange.bind(this);
    this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(this);
    this._handleStatusChange = this._handleStatusChange.bind(this);
    this._handleRemoveSuccessAlert = this._handleRemoveSuccessAlert.bind(this);
    this._handleTogglePrintPanel = this._handleTogglePrintPanel.bind(this);
    this._handleExportCsv = this._handleExportCsv.bind(this);
    this._handleExportEmail = this._handleExportEmail.bind(this);
    this._countExportRows = this._countExportRows.bind(this);
    this._toggleExportModal = this._toggleExportModal.bind(this);
    this.onSelectDataFromCheckbox = this.onSelectDataFromCheckbox.bind(this);
  }

  componentDidMount(){
    const { email } = this.props.injectedProps;
    const { categoryOptions } = this.props;
    if(!categoryOptions.options.length){
      this.props.bindCategoryOption();
    } else {
      const categoryId = this._getDefaultCategoryId();
      if(categoryId){
        this.setState({
          _params: { ...this.state._params, category_id: categoryId }
        }, () => this._refreshList());
      }
    }
    Analytics.recordPageView('warehouse', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  componentWillUnmount(){
    this._unmounted = true;
  }

  _setStateIfMounted(patch){
    if (!this._unmounted) this.setState(patch);
  }

  componentWillReceiveProps(nextProps){
    const { updateStatus, isSubmit, isFetch } = nextProps.sellRequest;
    if(isFetch !== this.props.sellRequest.isFetch && !isFetch){
      if(nextProps.sellRequest.error===null){
        const { data, ...pagination  } = nextProps.sellRequest.list;
        this.setState({
          _list: data,
          _pagination: pagination
        })
      }
    }
    if(this.props.categoryOptions.options.length === 0 && nextProps.categoryOptions.options.length > 0){
      const found = nextProps.categoryOptions.options.find(
        cat => cat.label.toLowerCase() === DEFAULT_CATEGORY_NAME.toLowerCase()
      );
      if(found && !this.state._params.category_id){
        this.setState({
          _params: { ...this.state._params, category_id: found.value }
        }, () => this._refreshList());
      }
    }
  }

  _getDefaultCategoryId(){
    const { categoryOptions } = this.props;
    const found = categoryOptions.options.find(
      cat => cat.label.toLowerCase() === DEFAULT_CATEGORY_NAME.toLowerCase()
    );
    return found ? found.value : null;
  }

  shouldComponentUpdate(nextProps, nextState){
    if(nextProps.sellRequest.isSubmit&&nextProps.sellRequest.isSubmit!==this.props.sellRequest.isSubmit){
      return false;
    }
    return true;
  }

  _handleApplyFilter(payloadFilter){
    this.setState({
      _params: {
        ...this.state._params,
        ...payloadFilter,
        page: 1
      }
    },()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key] != '')
    .forEach(key=> params[key] = rawParams[key]);
    return this.props.getList({params});
  }

  _refreshList(){
    // Exclude page...
    const { page, ..._params } = this.state._params;
    this.setState({
      _params:{ ..._params }
    },() => {
      this._getList(this.state._params)
        .then(() => {
          this.setState({ isDataLoaded: true }); 
        })
    });
  }

  _handleResetFilter(e){
    e.preventDefault();
    const categoryId = this._getDefaultCategoryId();
    this.setState({
      _params:{
        ...defaultParams,
        ...(categoryId ? { category_id: categoryId } : {})
      },
      _isResetFilter: true
    },()=>this._getList(this.state._params));
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _toggleFilterPanel(){
    this.setState({
      _filterOpen:!this.state._filterOpen
    })
  }

  _handleParamsChange(e) {
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleCheckedChange(e) {
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleParamsChangeAndSubmit(e){
    // Exclude page...
    const { page , ..._params } = this.state._params;
    _params[e.target.name] = e.target.value;
    _params.page = 1;
    this.setState({_params},()=>{
      this._getList(this.state._params);
    });
  }

  _handleTogglePrintPanel(e){
    const filterState = this.state._filterOpen?{_filterOpen:!this.state._filterOpen}:{};
    this.setState({
      ...filterState,
      _printOpen:!this.state._printOpen});
  }

  _toggleExportModal(){
    if(this.state._isExporting) return;
    this.setState({ _exportModalOpen: !this.state._exportModalOpen });
  }


  _exportParams(filters){
    const { page, per_page, ..._rest } = this.state._params;
    const panel = {};
    Object.keys(_rest)
      .filter(key => _rest[key] != '')
      .forEach(key => { panel[key] = _rest[key]; });
    return toWarehouseParams(panel, filters);
  }

  _countExportRows(filters){
    return countRows(goClient(), '/admins/sells', this._exportParams(filters));
  }

  _isAdmin(){
    const roles = (this.props.injectedProps && this.props.injectedProps.roles) || [];
    const list = Array.isArray(roles) ? roles : String(roles).split(',');
    return list.some(r => ADMIN_ROLES.includes(String(r).trim()));
  }

  async _handleExportCsv(filters, columns){
    if(this.state._isExporting) return;
    this.setState({ _isExporting: true, _exportProgress: 0, _exportRowCount: 0, _emailStatus: null });
    try {
      const rows = await fetchAllPages(goClient(), '/admins/sells', { ...this._exportParams(filters), without_append: 1 }, {
        onProgress: (progress, count) => this.setState({ _exportProgress: progress, _exportRowCount: count })
      });
      if (!rows.length) {
        this.setState({ _isExporting: false, _exportProgress: 0, _exportRowCount: 0 });
        window.alert('No warehouse stock matches the selected options.');
        return;
      }
      const stamp = new Date().toISOString().slice(0, 10);
      downloadCsv(rowsToCsv(rows.map(item => pickColumns(exportRow(item), columns))), `warehouse_${stamp}.csv`);
      this.setState({ _isExporting: false, _exportProgress: 100, _exportModalOpen: false });
    } catch (err) {
      this.setState({ _isExporting: false, _exportProgress: 0, _exportRowCount: 0 });
      if (err instanceof ExportLimitError) { window.alert(err.message); return; }
      if (isRequestError(err)) { window.alert('Export failed. Please try again.'); return; }
      throw err;
    }
  }

  async _handleExportEmail(filters, columns){
    if(this.state._isExporting) return;
    this._setStateIfMounted({ _isExporting: true, _emailStatus: null });
    try {
      const client = goClient();
      const filtersForServer = {};
      Object.entries(this._exportParams(filters)).forEach(([k, v]) => { filtersForServer[k] = String(v); });
      let status = await requestEmailExport(client, 'warehouse', filtersForServer, columns);
      this._setStateIfMounted({ _emailStatus: status });
      while (status && (status.state === 'queued' || status.state === 'waiting' || status.state === 'running')) {
        await new Promise(resolve => setTimeout(resolve, 5000));
        if (this._unmounted) return;
        status = await exportStatus(client, status.id);
        this._setStateIfMounted({ _emailStatus: status });
      }
      this._setStateIfMounted({ _isExporting: false });
    } catch (err) {
      const data = err && err.response && err.response.data;
      const message = data && data.errors && data.errors.columns ? data.errors.columns.join(' ') : (data && data.message) || 'Email export failed. Please try again.';
      this._setStateIfMounted({ _isExporting: false, _emailStatus: { state: 'failed', message } });
    }
  }

  _handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params},()=>this._getList(this.state._params));
  }

  _handleStatusChange(e,{id, product_variant_id, status}){
    if(!this.props.sellRequest.isSubmit){
      const { _localUpdateStatus } = this.state;
      const items = _localUpdateStatus.filter(item=>item.id!==id);
      this.setState({
        _localUpdateStatus: [...items, { id, newStatus: e.target.value, oldStatus: status }]
      })
      this.props.updateStatus(id, {product_variant_id,status:e.target.value})
    }
  }

  _handleRemoveSuccessAlert(){
    this.setState({
      _successAlertOpen: !this.state._successAlertOpen
    })
  }

  _onRenderPagination(){
		if(this.props.sellRequest.list.status_code===200&&this.props.sellRequest.list.data.length) {
      return (
        <Paginations
          isLoading={this.props.sellRequest.isFetch}
          size="sm"
          lastPage={this.props.sellRequest.list.last_page}
          perPage={this.props.sellRequest.list.per_page}
          total={this.props.sellRequest.list.total}
          maxPage={8}
          path={this.props.sellRequest.list.path}
          currentPage={this.props.sellRequest.list.current_page}
          prevPageUrl={this.props.sellRequest.list.prev_page_url}
          nextPageUrl={this.props.sellRequest.list.next_page_url}
          handleGotoCallback={this._handleGoto}
          onCurrentPageChanged={currentPage => {
            window.scrollTo({
              top: this.tableRef.offsetTop+25,
              behavior: 'smooth'
            })
          }}
        />
      )
		}
		return null;
  }

  onSelectDataFromCheckbox(param){
    if(this.state.selectedData.length === 0){
      this.setState({selectedData: [param]});
      return;
    }

    const temp = [...this.state.selectedData];

    const isAlreadySelected = temp.some(el=>el.id === param.id);
    if(isAlreadySelected){
      const newData = temp.filter(el=>el.id !== param.id);
      this.setState({selectedData: newData});
      return;
    }

    temp.push(param);
    const newData = temp;
    this.setState({selectedData: newData});
  }

  render() {
    return (
      <div className="animated fadeIn">
        <ExportModal
          isOpen={this.state._exportModalOpen}
          toggle={this._toggleExportModal}
          title="Export Warehouse List"
          screen="warehouse"
          columns={WAREHOUSE_EXPORT_COLUMNS}
          isAdmin={this._isAdmin()}
          defaultFilters={WAREHOUSE_EXPORT_DEFAULTS}
          renderFilters={(filters, setFilter, disabled) => (
            <WarehouseExportFilters filters={filters} setFilter={setFilter} disabled={disabled}
              loadLanguages={() => loadLanguageOptions(this.state._params.category_id)} />
          )}
          countRows={this._countExportRows}
          onDownload={this._handleExportCsv}
          onEmail={this._handleExportEmail}
          isExporting={this.state._isExporting}
          progress={this.state._exportProgress}
          rowCount={this.state._exportRowCount}
          maxRows={EXPORT_MAX_ROWS}
          emailStatus={this.state._emailStatus}
          userEmail={this.props.injectedProps && this.props.injectedProps.email}
        />
        <Row>
          <Col xs="12">
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Warehouse List</span>
                </Title>
                {this.state.isDataLoaded && <Toolbars
                  isOpen={this.state._filterOpen}
                  isOpenPrint={this.state._printOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}
                  onOpenExportCsv={this._toggleExportModal}
                  exporting={this.state._isExporting}
                  onTogglePrint={this._handleTogglePrintPanel}
                />}
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel
                  {...this.state._params}
                  isOpen={this.state._filterOpen}
                  onApplyFilter={this._handleApplyFilter}
                  isReset={this.state._isResetFilter}
                  onResetFilterCallback={()=>this.setState({_isResetFilter: false, _filterOpen: false})}
                />
              </FilterContainer>
              <CardBody>
                <Alert color="info" isOpen={this.state._successAlertOpen} toggle={this._handleRemoveSuccessAlert}>
                  <strong>Your list has been updated,</strong> maybe it can affect with your filter. Click (<i className="fa fa-refresh"></i>) button to refresh list.
                </Alert>
                <List
                  innerRefs={tableRef => this.tableRef = tableRef}
                  data={this.state._list}
                  isLoading={this.props.sellRequest.isFetch}
                  from={this.state._pagination.from}
                  to={this.state._pagination.to}
                  perPage={this.state._pagination.per_page}
                  currentPage={this.state._pagination.current_page}
                  total={this.state._pagination.total}
                  statusCode={this.state._pagination.status_code}
                  defaultRoute={DEFAULT_ROUTE}
                  selectedData={this.state.selectedData}
                  setSelectedData={(selectedData)=>{
                    this.setState({selectedData});
                  }}
                  onSelectDataFromCheckbox={this.onSelectDataFromCheckbox}
                  isOpenPrint={this.state._printOpen}
                  onRenderHeader={()=>(
                    <tr>
                      <Th>No.</Th>
                      <Th>Product</Th>
                      <Th style={{ minWidth: '200px', maxWidth: '200px', width: '200px' }}>Rack</Th>
                      <Th>Price</Th>
                      <Th>Updated</Th>
                      <Th>Status</Th>
                      <Th>Action</Th>
                    </tr>
                  )}
                />
                {this._onRenderPagination()}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
const mapStateToProps=({sellRequest, masterCategories, auth: { isFetch, isLogged, roles, id, email }})=> {
	return {
    sellRequest,
    guardData: { isFetch, isLogged, roles, id, email },
    categoryOptions:masterCategories
	}
}
const mapDispatchToProps=(dispatch)=> {
	return {
    getList:(filter)=>dispatch(getListUserSell(filter)),
    bindCategoryOption:()=>dispatch(getCategoryOptionList())
	}
}
const enchance = connect(mapStateToProps,mapDispatchToProps);
export default enchance(privateView(Warehouse, ['supervisor','sale_supervisor','cashier']))
